module.exports = __webpack_public_path__ + "assets/img/angle-down.b5782dd2.svg";